import React, { useEffect, useMemo } from 'react';

import { Controller, UseFormReturn } from 'react-hook-form';

import { useQueryGetCardUrgent } from 'api/queries/getCardUrgent.query';

import classes from 'components/common/GlobalFiltersInPage/Filters.module.scss';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import { OptionValue } from 'components/common/GlobalFiltersInPage/components/WbsFilter/wbsFilter';
import { FilterLabels } from 'components/common/GlobalFiltersInPage/globalFiltersInPage.utils';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';

import { Select } from 'components/DesignSystem/Select';

type Option = {
    id?: number;
    value: string;
    label: string;
};

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: string;
    isSelected?: boolean;
    versionId?: number;
}

export const UrgentFilter = ({
    name,
    methods,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
    versionId,
}: Props) => {
    const { data, isSuccess } = useQueryGetCardUrgent({
        metaDataId: versionId,
    });

    const options: Option[] = useMemo(() => {
        return (
            data?.map((option) => {
                return {
                    id: option?.id,
                    value: option.name,
                    label: option.label,
                };
            }) ?? []
        );
    }, [data]);

    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady || !isSuccess) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: isSuccess });
    }, [value, name, filtersStatusRef, isSuccess]);

    const handleChange = (option: ISelectOption<OptionValue> | null) => {
        methods?.setValue(name, option ? option.value : null);
        handleFilters && handleFilters();
    };

    return isSelected ? (
        <div data-testid={'battlecards-filters-urgent'} className={classes.selectWrapper}>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>>
                        id={'battlecards-filters-urgent'}
                        {...field}
                        value={options.find((option) => option.value === value)}
                        onChange={handleChange}
                        options={options}
                        isClearable={true}
                        label={FilterLabels.URGENT_TYPE_CARD_BOARD}
                    />
                )}
                name={name}
                control={methods?.control}
            />
        </div>
    ) : null;
};
